import React from "react";
import { TabList as ReactTabList } from "react-tabs";

import { styled, themeGet } from "@catchoftheday/theme";

import { ListStyleProps, listStyleProps } from "../List";

export const TabList = styled(ReactTabList)<ListStyleProps>`
  display: flex;
  border-bottom: 1px solid ${themeGet("colors.grey")};
  padding: 0;

  ${listStyleProps};
`;

(TabList as any).tabsRole = "TabList";

export type TabListProps = ListStyleProps &
  React.ComponentProps<typeof TabList>;

export default TabList;
